import React from "react";
import { path } from "ramda";
import { withAuthProvider } from "../../../lib/auth";
import ProJobModal from "./ProJobModal";

const isPgaProJob = (job) =>
  path(["applicantGroup"], job) === "PGA Professional Only";
const isManageJob = path(["state", "manageJob"]);
const canSeePgaProJob = path(["canSeePgaProJob"]);

export const Gatekeeper = ({
  isLoggedIn,
  me,
  job,
  children,
  history,
  location,
}) => {
  if (isPgaProJob(job)) {
    if (isManageJob(location)) {
      return children;
    }
    if (!canSeePgaProJob(me)) {
      return !isLoggedIn ? (
        <ProJobModal view={"notLoggedIn"} {...{ history, location }} />
      ) : (
        <ProJobModal view={"accessDenied"} {...{ history, location }} />
      );
    }
  }

  return children;
};

export default withAuthProvider(Gatekeeper);
